module.exports = __webpack_public_path__ + "img/home_banner.164141e5.png";